import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import PromotionManager from '../../../../views/PromotionManager/PromotionManager';

const PromotionManagerPageRoute = () => {
    return (        
        <Routes>
            <Route path="" element={<PromotionManager />} />            
        </Routes>        
    );
};

export default PromotionManagerPageRoute;